import React, { Component } from "react";
import * as Theme from "../../../app/Theme";
import * as HLConst from "../NonVisual/HLConst";
import HLNavBtnDiv from "../Other/HLNavBtnDiv";
// import Info from "@material-ui/icons/Info";
// import IconButton from '@material-ui/core/IconButton';
// import TLabel from "../../common/TLabel";
// import TButton from "../../common/TButton";
// import * as GBConst from "../../GB/GBConst";
// import HLDownloadGuideBtn from "../Other/HLDownloadGuideBtn";

class HLWelcomeForm extends Component {
    static propTypes = {};

    static defaultProps = {};

    state = {};

    //==================================================================================================================
    //
    //                                              Event Handlers
    //
    //==================================================================================================================

    onPageChange = (pageID) => {
        this.props.onPageChange(pageID);
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    renderTextDiv = () => {
        let textDiv = (
            <div
                style={{
                    // backgroundColor : Theme.HL_PrimaryColor,
                    // color           : "white",
                    marginLeft: Theme.leftIndent,
                    ...Theme.textFontStyle,
                }}
            >
                <p
                    style={{
                        color: Theme.HL_SecondaryColor,
                        ...Theme.labelFontStyle,
                        fontSize: 24,
                        textDecoration: "underline",
                    }}
                >
                    Welcome to H-LiST
                </p>

                <p
                    style={{
                        fontSize: 20,
                        fontStyle: "italic",
                    }}
                >
                    Supporting efficient resource use to save the most lives in humanitarian settings
                </p>

                <p>
                    The Humanitarian Lives Saved Tool (H-LiST) approach is an evidence-based, step-by-step process
                    developed for use in humanitarian settings to provide recommendations on which maternal and child
                    health, nutrition and water, sanitation and hygiene (WASH) interventions, at specified coverage
                    levels, can save the most lives. The approach also includes guidance on developing and costing
                    context-specific activities to achieve the specified intervention coverage levels.
                </p>

                <p
                    style={{
                        fontSize: 14,
                        fontStyle: "italic",
                    }}
                >
                    H-LiST was developed by the Center for Humanitarian Health, Johns Hopkins University, in
                    collaboration with the Lives Saved Tool (LIST) team. Both efforts are supported by the Bill &
                    Melinda Gates Foundation.
                </p>
            </div>
        );

        return textDiv;
    };

    render() {
        const navBtnDiv = (
            <HLNavBtnDiv onNextBtnClick={() => this.onPageChange(HLConst.introForm)} showBackBtn={false} />
        );

        return (
            <div
                style={{
                    height: Theme.HL_FooterPosition,
                }}
            >
                {this.renderTextDiv()}
                {navBtnDiv}
            </div>
        );
    }
}

export default HLWelcomeForm;
